/**
 *
 * @module accessStateData
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';

import AccessContextState from './accessContextState';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class AccessStateData
 * @desc Represents the access state data.
 *
 */
export default class AccessStateData {

    /**
     *
     * @param {String} token
     * @param {String} refreshToken
     * @param {AccessContextState} contextState
     * @throws {InvalidArgumentException}
     *
     */
    constructor(token, refreshToken, contextState) {

        const errorMessage = {
            ctor: 'AccessStateData(token, refreshToken, contextState)',
            get token() {
                return `${this.ctor} token should be a String with length`;
            },
            get refreshToken() {
                return `${this.ctor} refreshToken should be a String with length`;
            },
            get contextState() {
                return `${this.ctor} needs valid AccessContextState`;
            }
        };

        nonEmptyString(token, errorMessage.token, InvalidArgumentException);
        nonEmptyString(refreshToken, errorMessage.refreshToken, InvalidArgumentException);
        instanceStrict(contextState, AccessContextState, errorMessage.contextState, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         * @desc The primary access token.
         *
         */
        this.token = token;

        /**
         *
         * @access public
         * @type {String}
         * @desc The token needed for refreshing and obtaining a new token.
         *
         */
        this.refreshToken = refreshToken;

        /**
         *
         * @access public
         * @type {AccessContextState}
         * @desc The modes or permissions the token provides.
         *
         */
        this.contextState = contextState;

    }

}



// WEBPACK FOOTER //
// ./src/token/accessStateData.js